export default "__VITE_ASSET__i1q3nZuZ__"